<div class="bg-white rounded-lg">
  <div class="bg-[#073c52] flex items-center justify-center">
    <span class="text-2xl py-2 text-center font-medium text-white">{{
      data.header ?? "Confirmation"
    }}</span>
  </div>

  <div class="p-6">
    <p class="py-4 px-1 text-xl text-gray-700">
      {{ data.body || "Are you sure you want to proceed?" }}
    </p>
    <div class="flex justify-end space-x-2">
      <button
        (click)="handleConfirm(false)"
        class="bg-gray-300 hover:bg-gray-400 text-red-600 font-medium !text-[16px] py-2 px-4 rounded"
      >
        {{ data.cancelBtnText || "Cancel" }}
      </button>
      <button
        (click)="handleConfirm(true)"
        class="bg-gray-300 hover:bg-gray-400 text-[#255D16] font-medium !text-[16px] font-600 py-2 px-4 rounded"
      >
        {{ data.confirmBtnText || "Confirm" }}
      </button>
    </div>
  </div>
</div>
